import React, { Component } from 'react';
import { Query } from 'react-apollo';
import gql from '@jetshop/core/gql';
import styled from 'react-emotion';
import { Link } from 'react-router-dom';
import t from '@jetshop/intl';

const buttonColors = {
  Blå: '#1335F4',
  Sininen: '#1335F4',
  Brun: '#814B16',
  Ruskea: '#814B16',
  Cerise: '#E641A7',
  Kirsikka: '#E641A7',
  Grön: '#38BA6A',
  Vihreä: '#38BA6A',
  Gul: '#FFE200',
  Keltainen: '#FFE200',
  Rosa: '#FFB4CE',
  Roosa: '#FFB4CE',
  Röd: '#D10020',
  Punainen: '#D10020',
  Svart: '#000000',
  Musta: '#000000',
  Vit: '#FFFFFF',
  Valkoinen: '#FFFFFF',
  Orange: '#F4920E',
  Oranssi: '#F4920E'
};

const VartiantHeading = styled('h2')`
  font-size: 1.125rem;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
`;

const HalfButtonSharedCSS = `
border-radius: 0;
border-top-left-radius: 28px;
border-top-right-radius: 28px;
width: 27px;
height: 14px;
`;

const HalfButtonBeforeCSS = `
${HalfButtonSharedCSS}
transform: rotate(-35deg);
left: -1px;
top: 4px;
`;

const HalfButtonAfterCSS = `
${HalfButtonSharedCSS}
transform: rotate(145deg);
top: 14px;
left: 6px;
`;

const VariantButton = styled(Link)`
  display: inline-block;
  width: 34px;
  height: 34px;
  position: relative;
  border-radius: 50%;
  margin-right: 1rem;
  border: 1px solid transparent;
  ${props =>
    props.color === 'Vit' &&
    `
    width: 34px;
    height: 34px;
  `}
  &:before, &:after {
    content: '';
    width: 28px;
    height: 28px;
    position: absolute;
    top: 2px;
    left: 2px;
  }
  &:before {
    border-radius: 50%;
    border: 1px solid transparent;
    background: ${({ color }) => buttonColors[color]};
    ${props => props.color === 'Vit' && `border: 1px solid #e4e4e4;`}
  }

  ${props =>
    props.color === 'Svart/Orange' &&
    `
    &:before {
      background: ${buttonColors['Svart']};
      ${HalfButtonBeforeCSS};
    }
    &:after {
      background: ${buttonColors['Orange']};
      ${HalfButtonAfterCSS};
    }
  `}

  ${props =>
    props.color === 'Röd/Svart' &&
    `
    &:before {
      background: ${buttonColors['Svart']};
      ${HalfButtonBeforeCSS};
    }
    &:after {
      background: ${buttonColors['Röd']};
      ${HalfButtonAfterCSS};
    }
  `}

  ${props =>
    props.color === 'Röd/Blå' &&
    `
    &:before {
      background: ${buttonColors['Röd']};
      ${HalfButtonBeforeCSS};
    }

    &:after {
      background: ${buttonColors['Blå']};
      ${HalfButtonAfterCSS};
    }
  `}

  &:last-of-type {
    margin-right: 0;
  }
  &.active {
    border: 1px solid #000;
  }
`;

const ButtonContainer = styled('div')`
margin-bottom: 1rem;
  // ${({ theme }) => theme.below.md} {
  //   margin-bottom: 1rem;
  // }
`;

class ProductVariants extends Component {
  render() {
    const rawArticleNumber = this.props.articleNumber;
    //const articleNumber = rawArticleNumber.split('-')[0]+'-';
    const articleNumber = rawArticleNumber.substring(0, 8);
    const productRoute = this.props.primaryRoute;
    const currentProductCat = productRoute.path.split('/')[1];

    return articleNumber ? (
      <Query query={GET_PRODUCT_VARIANTS} variables={{ articleNumber }}>
        {({ data, loading }) => {
          if (loading) return '';

          if (data) {
            const variants = data.search.products.result;

            let filterVariants = variants.filter(variant => {
              return currentProductCat ===
                variant.primaryRoute.path.split('/')[1]
                ? variant
                : null;
            });

            filterVariants.sort(function(a, b) {
              return a.name.localeCompare(b.name);
            });

            return (
              <>
                {filterVariants.map((variant, i) => {
                  return variant.customFields.filter(
                    field => field.title === 'Färg'
                  )[0];
                }) && <VartiantHeading>{t('Colors')}</VartiantHeading>}

                <ButtonContainer>
                  {filterVariants.map((variant, i) => {
                    const variantWithColor = variant.customFields.filter(
                      field => field.title === 'Färg'
                    )[0];
                    if (variant.customFields && variantWithColor) {
                      const color = variantWithColor.stringValue;
                      return (
                        <VariantButton
                          key={i}
                          to={variant.primaryRoute.path}
                          color={color}
                          className={
                            rawArticleNumber === variant.articleNumber
                              ? 'active'
                              : null
                          }
                        />
                      );
                    } else {
                      return null;
                    }
                  })}
                </ButtonContainer>
              </>
            );
          } else {
            return null;
          }
        }}
      </Query>
    ) : null;
  }
}

const routecrumbFragment = gql`
  fragment Routecrumb on Route {
    id
    path
    slug
    object {
      breadcrumbText
    }
    parents {
      id
      path
      slug
      object {
        breadcrumbText
      }
    }
  }
`;

const GET_PRODUCT_VARIANTS = gql`
query getProductVariants($articleNumber: String!) {
  search(term: $articleNumber) {
    products {
      result {
        id
        name
        articleNumber
        primaryRoute {
          ${routecrumbFragment}
        }
        customFields {
          title
          ... on CustomStringField {
            stringValue: value
          }
        }
        images {
          alt
          title
          url
        }
      }
    }
  }
}
`;

export default ProductVariants;
